import { Card, SearchBar, List } from "antd-mobile";
import HomePage from "./pages/HomePage";
import { debounce } from "lodash-es";
import { message, Modal } from "antd";
import {
  Form,
  Input,
  TextArea,
  Button,
  ImageUploader,
  Picker,
  DatePicker,
} from "antd-mobile";
import { RefObject, useEffect, useState } from "react";
import { ImageUploadItem } from "antd-mobile/es/components/image-uploader";
import type { DatePickerRef } from "antd-mobile/es/components/date-picker";
import AMapLoader from "@amap/amap-jsapi-loader";
import dayjs from "dayjs";
import axios from "axios";
import addressImg from "./assets/address.png";
import aizhushou from "./assets/aizhushou.jpg";
import "./App.less";
import ResultPage from "./pages/ResultPage";
import QueryPage from "./pages/QueryPage";
import ListPage from "./pages/ListPage";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  useParams,
} from "react-router-dom";
import Search from "antd/es/transfer/search";

// export const HOST = "http://223.84.69.148:5000";
export const HOST = "https://www.wlglj.cn/abc";

const fileToBase64 = (
  file: File
): Promise<{ fileName: string; fileContent: string }> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file); // 读取文件并转换为 Base64
    reader.onload = () => {
      resolve({
        fileName: file.name,
        fileContent: reader.result as string,
      });
    };
    reader.onerror = (error) => reject(error);
  });
};

function SubmitPage() {
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const back = () => {
    navigate(-1);
  };
  const [fileList, setFileList] = useState<ImageUploadItem[]>([]);
  const [address, setAddress] = useState("");
  const [searchTips, setSearchTips] = useState([]);
  const [open, setOpen] = useState(false);
  const [map, setMap] = useState();
  const [form] = Form.useForm();
  const [typeOptions, setTypeOptions] = useState([]);
  const [typeVisible, setTypeVisible] = useState(false);
  const [typeValue, setTypeValue] = useState("");
  // 文件信息
  const [fileInfo, setFileInfo] = useState([]);
  // 图形验证码
  const [captchaInfo, setCaptchaInfo] = useState({
    CodeData: "",
    VerifyKey: "",
  });

  // 提交loading
  const [loading, setLoading] = useState(false);

  // 获取验证码
  const getCaptcha = () => {
    // 获取图形验证码
    axios.get(`${HOST}/sys/api/common/getadminverifycode`).then((res) => {
      setCaptchaInfo(res.data.data);
    });
  };

  useEffect(() => {
    window._AMapSecurityConfig = {
      securityJsCode: "6455bf03253c49b427d24b00e4fffe19",
    };
    // 获取诉求类型
    axios(`${HOST}/sys/api/exchange/order/getordertype`, {
      method: "POST",
    }).then((res) => {
      const arr = res.data?.data.map((item) => ({
        label: item.name,
        value: item.id,
      }));
      console.log("arr", arr);
      setTypeOptions(arr);
      // 设置typeid
      setTypeValue(params.get("id"));
      form.setFieldsValue({
        typeId: params.get("id"),
      });
    });
    // 获取图形验证码
    getCaptcha();
  }, []);
  const handleLocationSelect = async () => {
    try {
      setOpen(true);

      // 等待Modal渲染完成
      await new Promise((resolve) => setTimeout(resolve, 100));

      const AMap = await AMapLoader.load({
        key: "f4d4070ae77e22d7be8ea3d794c055bd",
        version: "2.0",
        plugins: [
          "AMap.PlaceSearch",
          "AMap.AutoComplete",
          "AMap.Geolocation",
          "AMap.Geocoder",
        ],
      });

      const map = new AMap.Map("map-container", {
        zoom: 14,
      });
      setMap(map);
      const geocoder = new AMap.Geocoder();
      const geolocation = new AMap.Geolocation();

      // 添加点击事件监听器
      map.on("click", (e) => {
        const lnglat = e.lnglat;
        geocoder.getAddress(
          [lnglat.getLng(), lnglat.getLat()],
          (status, result) => {
            if (status === "complete" && result.info === "OK") {
              const address = result.regeocode.formattedAddress;

              setAddress(address);
              // 地图移动到该位置
              map.setCenter([lnglat.getLng(), lnglat.getLat()]);
              map.clearMap();
              // 添加标记
              new AMap.Marker({
                position: [lnglat.getLng(), lnglat.getLat()],
                map: map,
              });
            }
          }
        );
      });

      // 获取当前位置
      geolocation.getCurrentPosition((status, result) => {
        console.log("获取当前位置status", status);
        console.log("获取当前位置result", result);
        if (status === "complete") {
          map.setCenter([result.position.lng, result.position.lat]);
        }
      });
    } catch (error) {
      let errorMessage = "地图加载失败";
      if (error instanceof Error) {
        errorMessage = `地图加载失败: ${error.message}`;
        console.error("详细错误信息：", {
          message: error.message,
          stack: error.stack,
        });
      }
    }
  };
  const onFinish = (values: any) => {
    if (loading) return;
    setLoading(true);
    const fileData = [];
    fileInfo.forEach((item) => {
      if (fileList.some((i) => i.url == item.url)) {
        fileData.push({
          fileName: item.fileName,
          fileContent: item.fileContent,
        });
      }
    });
    const params = {
      platformCode: "APP",
      title: values.title,
      orderContent: values.orderContent,
      typeId: values.typeId,
      typeName: typeOptions.filter((item) => item.value === values.typeId)[0]
        .label,
      eventTime: dayjs(values.eventTime).format("YYYY-MM-DD HH:mm:ss"),
      applicantName: values.applicantName,
      applicantPhone: values.applicantPhone,
      address: values.address,
      VerCode: values.VerCode,
      VerifyKey: captchaInfo.VerifyKey,
    };
    if (fileData.length > 0) {
      params.fileData = fileData;
    }
    console.log("params", params);
    axios
      .post(`${HOST}/sys/api/exchange/order/orderwrite`, params)
      .then((res) => {
        console.log("res1", res);
        if (res.data.code == 0) {
          navigate("/result");
        } else {
          message.error(res.data.message);
          getCaptcha();
        }
      })
      .catch((res) => {
        message.error(res.data.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div style={{ padding: "0 6px" }}>
      <div
        style={{
          height: 45,
          display: "flex",
          alignItems: "center",
          padding: "0 12px",
        }}
      >
        <div
          onClick={back}
          style={{
            fontSize: 24,
            fontFamily: "system-ui",
            transform: "scaleX(0.8)",
            cursor: "pointer",
          }}
        >
          ‹
        </div>
      </div>
      <div className="header">诉求提交</div>
      <div style={{ display: "flex", justifyContent: "end", marginBottom: 12 }}>
        <img
          style={{ height: 30 }}
          src={aizhushou}
          alt=""
          onClick={() => {
            window.open("https://aitest.liushaotou.ltd/userAI");
          }}
        />
      </div>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        footer={
          <Button
            block
            type="submit"
            color="primary"
            style={{ borderRadius: 20 }}
            loading={loading}
          >
            提交
          </Button>
        }
      >
        <Form.Item
          name="title"
          label={`${params.get("title")}标题`}
          rules={[
            { required: true, message: `请输入${params.get("title")}标题` },
          ]}
        >
          <Input placeholder={`请输入${params.get("title")}标题`} />
        </Form.Item>

        <Form.Item
          name="orderContent"
          label={`${params.get("title")}内容`}
          rules={[
            { required: true, message: `请输入${params.get("title")}内容` },
          ]}
        >
          <TextArea
            placeholder={`请详细描述您的${params.get("title")}内容`}
            maxLength={500}
            rows={4}
            showCount
          />
        </Form.Item>

        <Form.Item
          name="typeId"
          label="类型"
          rules={[{ required: true, message: "请选择类型" }]}
          disabled
          onClick={() => {
            setTypeVisible(true);
          }}
        >
          <div onClick={() => setTypeVisible(true)}>
            {typeValue ? (
              typeOptions.find((item) => item.value == typeValue)?.label
            ) : (
              <span style={{ color: "#D2D2D2" }}>请选择类型</span>
            )}
          </div>
        </Form.Item>

        <Form.Item
          name="eventTime"
          label="时间"
          rules={[{ required: true, message: "请选择时间" }]}
          trigger="onConfirm"
          onClick={(e, datePickerRef: RefObject<DatePickerRef>) => {
            datePickerRef.current?.open();
          }}
        >
          <DatePicker precision="second">
            {(value) =>
              value ? (
                dayjs(value).format("YYYY-MM-DD HH:mm:ss")
              ) : (
                <span style={{ color: "#D2D2D2" }}>请选择日期</span>
              )
            }
          </DatePicker>
        </Form.Item>

        <Form.Item
          name="address"
          label="地址"
          rules={[{ required: true, message: "请输入地址" }]}
          extra={
            <div style={{ display: "flex", alignItems: "center" }}>
              <img
                style={{ width: 18, height: 18, marginRight: 6 }}
                src={addressImg}
                alt=""
              />
              <div style={{ color: "#3460FB" }} onClick={handleLocationSelect}>
                获取定位
              </div>
            </div>
          }
        >
          <Input placeholder="定位不准？请手动输入地址" />
        </Form.Item>

        <Form.Item name="fileData" label="上传图片">
          <ImageUploader
            maxCount={3}
            value={fileList}
            onChange={setFileList}
            showUploadButton={fileList.length < 3}
            upload={async (file) => {
              const url = URL.createObjectURL(file);
              fileToBase64(file).then((res) => {
                fileInfo.push({
                  ...res,
                  url,
                });
                console.log("fileInfo", fileInfo);
                setFileInfo(fileInfo);
              });
              return { url };
            }}
          />
        </Form.Item>
        <Form.Item
          name="applicantName"
          label="您的姓名"
          rules={[{ required: true, message: "请输入您的姓名" }]}
        >
          <Input placeholder="请输入您的姓名" />
        </Form.Item>
        <Form.Item
          name="applicantPhone"
          label="您的电话"
          rules={[
            { required: true, message: "请输入您的电话" },
            { pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号码" },
          ]}
        >
          <Input placeholder="请输入您的电话" />
        </Form.Item>
        <Form.Item
          name="VerCode"
          label="验证码"
          extra={
            <img
              src={`data:image/png;base64,${captchaInfo.CodeData}`}
              onClick={getCaptcha}
            ></img>
          }
          rules={[{ required: true, message: "请输入验证码" }]}
        >
          <Input placeholder="请输入验证码" />
        </Form.Item>
      </Form>
      <Picker
        visible={typeVisible}
        columns={[typeOptions]}
        onClick={(e) => {
          e.stopPropagation();
        }}
        onCancel={() => setTypeVisible(false)}
        onConfirm={(v) => {
          setTypeValue(v[0]);
          form.setFieldsValue({
            typeId: v[0],
          });
          setTypeVisible(false);
        }}
      ></Picker>
      <Modal
        open={open}
        onCancel={() => {
          setOpen(false);
        }}
        afterClose={() => {
          setAddress("");
          setSearchTips([]);
        }}
        onOk={() => {
          form.setFieldsValue({
            address,
          });
          setOpen(false);
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <div style={{ position: "relative" }}>
            <SearchBar
              style={{ marginTop: 18 }}
              value={address}
              placeholder="请输入地址搜索"
              onChange={debounce((value) => {
                if (!value) {
                  setSearchTips([]);
                  setAddress("");
                  return;
                }
                setAddress(value);
                const autoComplete = new window.AMap.AutoComplete({
                  city: "全国",
                  citylimit: true,
                });
                autoComplete.search(value, (status, result) => {
                  if (status === "complete" && result.info === "OK") {
                    setSearchTips(result.tips || []);
                  }
                });
              }, 500)}
            />
            {searchTips.length > 0 && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  right: 0,
                  zIndex: 1000,
                  backgroundColor: "#fff",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                  borderRadius: "4px",
                  maxHeight: "200px",
                  overflowY: "auto",
                }}
              >
                <List>
                  {searchTips.map((tip: any) => (
                    <List.Item
                      key={tip.id}
                      onClick={() => {
                        setAddress(tip.name);
                        setSearchTips([]);
                        const geocoder = new AMap.Geocoder();
                        geocoder.getLocation(tip.name, (status, result) => {
                          if (status === "complete" && result.info === "OK") {
                            // const address = result.regeocode.formattedAddress;
                            const location = result.geocodes[0].location;
                            console.log(
                              "location",
                              location.getLng(),
                              location.getLat()
                            );
                            // // 地图移动到该位置
                            map?.setCenter([
                              location.getLng(),
                              location.getLat(),
                            ]);
                            map?.clearMap();
                            // // 添加标记
                            new AMap.Marker({
                              position: [location.getLng(), location.getLat()],
                              map: map,
                            });
                          }
                        });
                      }}
                    >
                      <div style={{ fontSize: "14px" }}>{tip.name}</div>
                      <div style={{ fontSize: "12px", color: "#999" }}>
                        {tip.district}
                      </div>
                    </List.Item>
                  ))}
                </List>
              </div>
            )}
          </div>
          <div id="map-container" style={{ width: "100%", height: "300px" }} />
        </div>
      </Modal>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/submit" element={<SubmitPage />} />
        <Route path="/result" element={<ResultPage />} />
        <Route path="/query" element={<QueryPage />} />
        <Route path="/list" element={<ListPage />} />
      </Routes>
    </Router>
  );
}

export default App;
